/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useModal } from "../../../context/ModalContext";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";
import { CloseIcon, PaymentOverdueIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { AvatarCustom, PetAvatars } from "../../../components";
import { useNavigate } from "react-router-dom";
import { MODALS } from "../../../config/params";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { useOverdueInvoiceStore } from "../../../hooks/redux-hooks/overdue-invoice-store/overdue-invoice.store";
import { IPetItemResponse } from "../../../services/pet-list/pet-list.interface";
import { PAGES_PATH } from "../../../navigation/params";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { userActivityLogger } from "../../../utils/mixpanel";
import { IPetDetail } from "../../../components/PetAvatars/PetAvatars";
import { IOverdueInvoiceOverallInfo, IOverdueInvoicePetInfo }
  from "../../../state/pendingInvoices/pendingInvoices.reducer";


const PendingInvoiceCancelledAlertModal = () => {
  const { openModal, closeModal } = useModal();
  const { cancelledWellnessPetList }=useOverdueInvoiceStore();
  const { petList } = usePetStore();
  const [petData, setPetData] = useState<IPetItemResponse[]>();


  const handleCta = () =>{
    openModal(MODALS.OVERDUE_CONTACT_MODAL);
    userActivityLogger(MIXPANEL_EVENTS.CONTACT_HOSPITAL_TRIGGERED, {
      referred_from: "non_payment_cancelled_popup",
    });
    closeModal();
  };

  const handleModalClose = () =>{
    cancelledWellnessPetList.forEach((petDetails) => {
      userActivityLogger(MIXPANEL_EVENTS.PLAN_CANCELLED_POP_UP_DISMISSED, {
        pet_name: petDetails.petName,
        plan_name: petDetails.planName,
      });
    });
    closeModal();
  };

  useEffect(()=>{
    if (petList && (cancelledWellnessPetList.length > 0)) {
      setPetData( petList?.filter((petData) => petData.id === cancelledWellnessPetList[0].petId));
    }
  }, [cancelledWellnessPetList, petList]);

  const formatPetNames = (bookingPetsName: string[])=>{
    if (!Array.isArray(bookingPetsName) || bookingPetsName.length === 0) return "";

    if (bookingPetsName.length === 1) {
      return `${bookingPetsName[0]}'s`;
    } else if (bookingPetsName.length === 2) {
      return `${bookingPetsName[0]} and ${bookingPetsName[1]}'s`;
    } else if (bookingPetsName.length === 3) {
      return `${bookingPetsName[0]}, ${bookingPetsName[1]} and ${bookingPetsName[2]}'s`;
    } else if (bookingPetsName.length > 3) {
      return `${bookingPetsName[0]}, ${bookingPetsName[1]}, ${bookingPetsName[2]} 
      and ${bookingPetsName.length - 3} other pets`;
    }

    return "";
  };

  return (
    <>
      {petData &&
        <div className="flex flex-col w-full xl:w-[24rem]">
          <div className="flex justify-end">
            <CloseIcon
              onClick={handleModalClose}
              className="text-light-black cursor-pointer"
            />
          </div>
          <div className="w-full flex flex-col items-center gap-3">
            <div>
              <AvatarCustom
                width={80}
                height={80}
                image={petData[0].image ? petData[0].image : ""}
                name={petData[0].name}
                isWellnessMember={false}
                isPlanOverdue={true}
                isDashBoardPetCardBooking={{ wellnessIconCoordinates: { x: "50", y: "-25" },
                  wellnessIcon: { width: 26, height: 26 } }}
              />
            </div>
            <div className="text-xl font-semibold text-center mx-8">
              {formatPetNames(cancelledWellnessPetList.map((pet: IOverdueInvoicePetInfo) => pet.petName))}&nbsp;
              GoodPet+ Plan Has Been Canceled for Non-Payment
            </div>
            <div className="flex flex-col w-full">
              <div className="flex justify-center mb-4">
                <div className="text-center">
                Please contact your GoodVets hospital to settle your account before booking any future services.
                </div>
              </div>
              <StyledBookingFlowButton
                disabled={false}
                fullWidth
                color="primary"
                className="!text-sm"
                size="small"
                onClick={handleCta}
              >
                  Contact Hospital
              </StyledBookingFlowButton>
            </div>
          </div>
        </div>}
    </>
  );
};

export default PendingInvoiceCancelledAlertModal;
